import { useGetEducationalVideoListV2 } from '@viome/viome-base/src/usecase/Education/EducationV2Query';

export const useGetEducationSeriesVideoList = ({
  screen,
}: {
  screen: string;
}) => {
  const {
    data: educarouselData,
    isLoading: isEducarouselLoading,
    isError: isEducarouselError,
  } = useGetEducationalVideoListV2(screen);

  return {
    educarouselData,
    isEducarouselLoading,
    isEducarouselError,
  };
};
